// Create a new file: src/utils/uuidUtils.ts

/**
 * Generate a UUID v4 string
 * This is used to create a new conversation ID when needed
 * @returns {string} UUID v4 string
 */
export function generateUUID(): string {
    // Implementation of UUID v4 in pure JavaScript
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  
  /**
   * Validate if a string is a valid UUID
   * @param {string} uuid String to validate
   * @returns {boolean} True if valid UUID
   */
  export function isValidUUID(uuid: string): boolean {
    const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return regex.test(uuid);
  }